<template>
  <div class="addImgBox" :class="{ 'no-mask': currentTab == 'tab2' }">
    <div class="addImgBox-card">
      <div class="close-btn" @click="closeAddImgBox()">
        <svg-icon icon-class="close" class="close-icon" />
      </div>

      <Tabs v-model="currentTab">
        <TabPane :label="$t('webirs.konvaCanvas.檔案圖片')" name="tab1">
          <label class="img_upload-btn" @click="addImgMode">
            <svg-icon class="img_upload-icon" iconClass="add_img" />
            <input @click="resetAddImageUploader()" ref="addImageUploader" type="file" accept="image/png, image/gif, image/x-png,image/jpeg" @change="addImgObj" />
          </label>
          <div class="img_upload-text">{{ $t('webirs.konvaCanvas.選取圖片作為物件') }}</div>
        </TabPane>
        <TabPane :label="$t('webirs.konvaCanvas.素材庫')" name="tab3">
          <div class="tab3-wrap">
            <div class="imgitem-wrap" v-for="(image, index) in images" :key="index" @click="addOpenClipArt(image.pathLong)">
              <img v-lazy="image.pathLong" alt="" />
            </div>
          </div>
        </TabPane>

      </Tabs>
    </div>
  </div>
</template>

<script>
import { Loading } from 'quasar'
import SvgIcon from '../../components/SvgIcon.vue'
import htkv from '../../api/htexKonvaTransformHT.js'
import Konva from "konva";
export default {
  name: 'AddImgBox',
  components: {
    SvgIcon
  },
  data() {
    return {
      currentTab: 'tab1',
      bgColors: ['#ffcdd2', '#BBDEFB', '#C8E6C9', '#FFF9C4', '#ffffff'],
      freecolor: '#C9C9C9',
      images: [],

    }
  },
  mounted() {
    this.importAll(require.context('../../assets/Openclipart', true, /\.png$/), this.images)
  },

  methods: {
    importAll(r, target) {
      r.keys().forEach(key => target.push({ pathLong: r(key), pathShort: key }))
    },
    resetAddImageUploader() {
      this.$refs.addImageUploader.value = ''
    },
    addImgMode() {
      this.$parent.select()
    },
    closeAddImgBox() {
      this.$parent.showAddImgBox = false
    },
    //上傳本地所選檔案圖片
    async addImgObj(e) {
      let that = this

      let stage = this.$parent.stage
      let layer = this.$parent.layer

      let fileName = e.target.files[0].name
      let compressFile

      let fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])
      fileReader.onload = e => {
        let imageObj = new Image()
        imageObj.setAttribute('crossOrigin', 'Anonymous')
        imageObj.src = e.target.result
        imageObj.onload = async function() {
          console.log(imageObj.width, imageObj.height)
          let ratio = that.$parent.calScaleRatio(imageObj.width, imageObj.height, 1024, 1024).ratio

          const canvas = document.createElement('canvas')
          const context = canvas.getContext('2d')

          const originalWidth = imageObj.width
          const originalHeight = imageObj.height

          const canvasWidth = originalWidth * ratio
          const canvasHeight = originalHeight * ratio

          canvas.width = canvasWidth
          canvas.height = canvasHeight

          context.drawImage(imageObj, 0, 0, canvasWidth, canvasHeight)
          console.log(canvasWidth, canvasHeight, '壓縮後的圖片長寬')
          let base64URL=canvas.toDataURL('images/jpeg', 1)
          
          if (that.$parent.mindMapInfo.isTool) { //如果是mindmap的tool要變成base64
           
            let currentIndex = layer?.children ? JSON.parse(JSON.stringify(layer?.children)).length - 1 : 1
            Konva.Image.fromURL(base64URL, function (image) {
              Loading.hide()
              console.log(image)
              let scaleRatio = image.width() > stage.width() ? stage.width() / image.width() / 2 : 0.8
              // image is Konva.Image instance
              image.setAttrs({
                uuid: htkv.genUUID(),
                x: stage.width() / 2 - Math.floor(Math.random() * 100),
                y: stage.height() / 2 - Math.floor(Math.random() * 100),
                width: image.width() * scaleRatio,
                height: image.height() * scaleRatio,
                draggable: true,
                src: base64URL,
                index: currentIndex
              })

              // stage.find('Transformer').destroy()
              let tr = new Konva.Transformer({
                anchorStroke: '#00a6ff',
                anchorFill: '#fff',
                anchorSize: 12,
                anchorCornerRadius: 5,
                anchorStrokeWidth: 2,
                borderStroke: '#6ac9fc',
                borderStrokeWidth: 2,
                borderDash: [3, 3],
                padding: 10,
                name: 'default'
              })
              stage.find('Transformer').forEach(function (ele) {
                if (ele.attrs.name == 'default') {
                  ele.destroy()
                }
              })
              layer.add(tr)
              tr.nodes([image])

              that.$parent.addMenuBtnToTr(tr, image)

              layer.add(image)
              layer.draw()

              //儲存undo歷史
              that.$parent.undoHistory.push({ action: 'delete', item: JSON.parse(JSON.stringify(image)) })
              //新增前一動應提供該物件的初始化Attr
              that.$parent.undoHistory.push({ action: 'update', item: JSON.parse(JSON.stringify(image)) })
              that.$parent.isModified = true
            })

          }
          else {
            compressFile = await that.$parent.dataURLtoFile(base64URL, fileName)
            let size = parseFloat(compressFile.size / 1000000).toFixed(4)
            if (size <= 3) {
              Loading.show()

              await that.$parent.konvaCanvasUploadFile(compressFile).then(res => {
                Loading.hide()
                Loading.show()
                let fileUrl = res.url
                let currentIndex = layer?.children ? JSON.parse(JSON.stringify(layer?.children)).length - 1 : 1
                // console.log(currentIndex,'currentIndex圖片')
                // console.log(fileUrl)
                // console.log(stage)
                Konva.Image.fromURL(fileUrl + '?' + that.$parent.blobSasRead, function (image) {
                  Loading.hide()
                  console.log(image)
                  let scaleRatio = image.width() > stage.width() ? stage.width() / image.width() / 2 : 0.8
                  // image is Konva.Image instance
                  image.setAttrs({
                    uuid: htkv.genUUID(),
                    x: stage.width() / 2 - Math.floor(Math.random() * 100),
                    y: stage.height() / 2 - Math.floor(Math.random() * 100),
                    width: image.width() * scaleRatio,
                    height: image.height() * scaleRatio,
                    draggable: true,
                    src: fileUrl,
                    index: currentIndex
                  })

                  // stage.find('Transformer').destroy()
                  let tr = new Konva.Transformer({
                    anchorStroke: '#00a6ff',
                    anchorFill: '#fff',
                    anchorSize: 12,
                    anchorCornerRadius: 5,
                    anchorStrokeWidth: 2,
                    borderStroke: '#6ac9fc',
                    borderStrokeWidth: 2,
                    borderDash: [3, 3],
                    padding: 10,
                    name: 'default'
                  })
                  stage.find('Transformer').forEach(function (ele) {
                    if (ele.attrs.name == 'default') {
                      ele.destroy()
                    }
                  })
                  layer.add(tr)
                  tr.nodes([image])

                  that.$parent.addMenuBtnToTr(tr, image)

                  layer.add(image)
                  layer.draw()

                  //儲存undo歷史
                  that.$parent.undoHistory.push({ action: 'delete', item: JSON.parse(JSON.stringify(image)) })
                  //新增前一動應提供該物件的初始化Attr
                  that.$parent.undoHistory.push({ action: 'update', item: JSON.parse(JSON.stringify(image)) })
                  that.$parent.isModified = true

                  if (that.$parent.mobileirs.IRSmode == 'Cowork') {

                    that.$parent.isSendByMe = true
                    let uuid = image.attrs.uuid
                    let position = { x: image.attrs.x - 30, y: image.attrs.y - 30 }
                    that.$parent.sendItemToHTWb(position, uuid, "add", image, 'addImg')

                  }

                })
              })

            } else {
              Loading.hide()
              that.$Message.warning(that.$t('webirs.konvaCanvas.所選圖片過大'))
            }
          } 
          that.$parent.showAddImgBox = false
        }
      }
    },
    addOpenClipArt(Imgurl) {
      let that=this
      let stage = this.$parent.stage
      let layer = this.$parent.layer
      let imageObj = new Image()
      let finallink = Imgurl.slice(0, 14) != 'data:image/png' ? window.location.origin + Imgurl : Imgurl
      let currentIndex=layer?.children ? JSON.parse(JSON.stringify(layer?.children)).length : 1

      imageObj.onload = function() {
        // console.log(imageObj)
        let image = new Konva.Image({
          x: stage.width() / 2 - Math.floor(Math.random() * 100),
          y: stage.height() / 2 - Math.floor(Math.random() * 100),
          image: imageObj,
          width: imageObj.width * 0.4,
          height: imageObj.height * 0.4,
          draggable: true,
          src: finallink,
          uuid: htkv.genUUID(),
          index:currentIndex,
          name: 'OpenClipArt'
        })
        let tr = new Konva.Transformer({
          anchorStroke: '#00a6ff',
          anchorFill: '#fff',
          anchorSize: 12,
          anchorCornerRadius: 5,
          anchorStrokeWidth: 2,
          borderStroke: '#6ac9fc',
          borderStrokeWidth: 2,
          borderDash: [3, 3],
          padding: 10,
          name: 'default'
        })
        stage.find('Transformer').forEach(function (ele) {
          if (ele.attrs.name == 'default') {
            ele.destroy()
          }
        })
        layer.add(tr)
        tr.nodes([image])

        that.$parent.addMenuBtnToTr(tr, image)

        layer.add(image)
        layer.draw()

        //儲存undo歷史
        that.$parent.undoHistory.push({ action: 'delete', item: JSON.parse(JSON.stringify(image)) })
        //新增前一動應提供該物件的初始化Attr
        that.$parent.undoHistory.push({ action: 'update', item: JSON.parse(JSON.stringify(image)) })
        that.$parent.isModified = true

        if (that.$parent.mobileirs.IRSmode == 'Cowork') {

          that.$parent.isSendByMe = true
          let uuid = image.attrs.uuid
          let position = { x: image.attrs.x - 30, y: image.attrs.y - 30 }
          that.$parent.sendItemToHTWb(position, uuid, "add", image, 'addImg')

        }
      }
      imageObj.src = finallink
      this.$parent.showAddImgBox = false
    },

  }
}
</script>

<style lang="less">
@import '../../assets/color.less';
.ivu-tabs-nav-container:focus .ivu-tabs-tab-focused,
.ivu-tabs-nav .ivu-tabs-tab-active {
  color: @light-color !important;
  &:hover {
    color: @light-color !important;
  }
}
.ivu-tabs-nav .ivu-tabs-tab:hover {
  color: @light-color !important;
}
.ivu-tabs-ink-bar {
  background-color: @light-color !important;
}
.no-mask {
  background-color: rgba(0, 0, 0, 0) !important;
}
.addImgBox {
  position: absolute;
  display: block;
  width: 100%;
  background-color: @editbtn-shadow;
  // border-radius: 5px;
  transition: 0.5s;
  color: black;
  height: 100%;
  z-index: 1003;
  .close-btn {
    position: absolute;
    top: -10px;
    right: -10px;
    width: 30px;
    height: 30px;
    line-height: 30px;
    background-color: @darken-gray;
    text-align: center;
    border-radius: 50%;
    cursor: pointer;
    z-index: 100;
    .close-icon {
      font-size: 16px;
    }
  }
  .addImgBox-card {
    top: 15%;
    width: 50%;
    min-height: 350px;
    transition: 0.5s;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background-color: @nomal-bgc;
    font-weight: bolder;
    padding: 10px 20px 20px 20px;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    z-index: 102;
    text-align: center;
    .divide-wrap {
      background-color: @nomal-bgc;
      padding: 10px 0px;
      .divide-line {
        background-color: @nomal-bgc;
        border-bottom: 0.5px solid rgb(192, 192, 192);
      }
    }
    .tab3-wrap {
      position: relative;
      width: 100%;
      height: 52vh;
      text-align: left;
      overflow: auto;
      .imgitem-wrap {
        display: inline-block;
        width: 10%;
        text-align: center;
        vertical-align: middle;
        padding: 10px 2px;
        margin: 0.5%;
        height: 15.5%;
        cursor: pointer;
        border-radius: 5%;
        background-color: #fff;
        &:hover {
          box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
        }
        img {
          cursor: pointer;
          height: auto;
          max-height: 100%;
          width: auto;
        }
      }
    }

    @media screen and (max-width: 768px) {
      input[type='color'] {
        cursor: pointer;
        display: inline-block;
        position: relative;
        top: -11px !important;
        -webkit-appearance: none;
        border: none;
        height: 30px !important;
        width: 30px !important;
        margin: 0px 10px;
      }
      input[type='color']::-webkit-color-swatch-wrapper {
        padding: 0;
      }
      input[type='color']::-webkit-color-swatch {
        border: none;
      }
      .bgColors-item {
        display: inline-block;
        height: 30px !important;
        width: 30px !important;
        margin: 0px 10px;
        cursor: pointer;
        border: 1px solid @darken-gray;
        &:hover {
          box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
        }
      }
    }
    .bgColors-wrap {
      position: relative;
      display: block;
      height: auto;

      input[type='color'] {
        cursor: pointer;
        display: inline-block;
        position: relative;
        top: -15px;
        -webkit-appearance: none;
        border: none;
        height: 40px;
        width: 40px;
        margin: 0px 10px;
      }
      input[type='color']::-webkit-color-swatch-wrapper {
        padding: 0;
      }
      input[type='color']::-webkit-color-swatch {
        border: none;
      }
      .bgColors-item {
        display: inline-block;
        height: 40px;
        width: 40px;
        margin: 0px 10px;
        cursor: pointer;
        border: 1px solid @darken-gray;
        &:hover {
          box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
        }
      }
    }
    .img_upload-text {
      margin-top: 20px;
    }
    .img_upload-btn {
      display: inline-block;
      border-radius: 50%;
      background-color: #fff;
      height: 120px !important;
      width: 120px !important;
      cursor: pointer;
      box-shadow: 0 1px 10px rgba(0, 0, 0, 0.2);
      margin-top: 30px;
      .img_upload-icon {
        font-size: 80px;
        color: @text-color !important;
        position: relative;
        top: 20px;
        left: 2px;
      }
      .imgbgc-icon {
        font-size: 80px;
        color: @text-color !important;
        position: relative;
        top: 20px;
        left: 0px;
      }
      input[type='file'] {
        display: none;
      }
      &:hover {
        background-color: @light-color;
        .img_upload-icon,
        .imgbgc-icon {
          color: white !important;
        }
      }
    }
  }
}
</style>
